// extracted by css-extract-rspack-plugin
export default {"jobsTable":"jobsTable-F4dd4i","tableHead":"tableHead-m607DB","primaryColumn":"primaryColumn-EKR03i","teamColumn":"teamColumn-IHGvjq","statusColumn":"statusColumn-DaSM8g"};